import { useIntl } from 'react-intl';
import { Col, Row } from 'reactstrap';
import { Filter } from 'lucide-react';

import Button from 'src/componentes/button';
import Checkbox from 'src/componentes/checkbox';
import DatePicker from 'src/componentes/date-picker';
import Drawer from 'src/componentes/drawer';
import PanelCollapse from 'src/componentes/panel-collapse';
import ColaboradorEGrupoSimplificadoLookup from 'src/lookups/ColaboradorEGrupoSimplificadoLookup';
import OrganizacaoLookup from 'src/lookups/item-organizacao';
import useAuth from 'src/hooks/useAuth';
import { capitalizeFirstLetter } from 'src/utils/string';

const RespostasFiltroDrawer = ({
  ehConfidencial = false,
  filtro,
  focusTrapPriority = 2,
  onAplicarFiltro,
  onChangeFiltro,
  onClearFiltro,
  onClose,
  open,
}) => {
  const intl = useIntl();
  const { terms: resources } = useAuth();

  return (
    <Drawer
      open={open}
      close={onClose}
      title={
        <div
          className="font-weight-bold pt-4 pb-4"
          style={{
            color: '#404040',
            fontSize: '1.5rem',
            fontWeight: 700,
          }}
        >
          {capitalizeFirstLetter(intl.formatMessage({ id: 'filtros' }))}
        </div>
      }
      position="right"
      size={430}
      zIndex={12000}
      focusTrap
      focusTrapPriority={focusTrapPriority}
      actions={
        <div
          style={{
            alignItems: 'center',
            display: 'flex',
            justifyContent: 'space-between',
            width: '100%',
          }}
        >
          <span
            style={{
              color: '#0D7E94',
              cursor: 'pointer',
              fontSize: 16,
              fontWeight: 'bold',
            }}
            onClick={onClearFiltro}
          >
            {intl.formatMessage({ id: 'limparTodos' })}
          </span>
          <Button
            color="primary"
            leftIcon={Filter}
            onClick={onAplicarFiltro}
            style={{ width: '7rem' }}
          >
            {intl.formatMessage({ id: 'label.filtrar' })}
          </Button>
        </div>
      }
      actionsStyle={{ borderTop: '1px solid #e4eaec', padding: 20 }}
      bodyStyle={{ overflowX: 'hidden', overflowY: 'auto' }}
      headerStyle={{
        borderBottom: '1px solid #e4eaec',
        paddingBottom: 0,
        paddingLeft: 20,
        paddingRight: 20,
        paddingTop: 0,
      }}
    >
      <PanelCollapse
        ehAccordionDrawer
        header={capitalizeFirstLetter(
          intl.formatMessage({ id: 'label.informacoesBasicas' })
        )}
        hideShadow
        open
      >
        <Row>
          <Col md={12}>
            <OrganizacaoLookup
              clearable
              compactMulti
              multi
              model={{
                label: capitalizeFirstLetter(resources.areas || resources.area),
                value: filtro.areas,
                requestChange: (value) => onChangeFiltro('areas', value),
              }}
            />
          </Col>
          <Col md={12}>
            <Checkbox
              className="pb-2"
              disabled={!filtro.areas || filtro.areas.length === 0}
              model={{
                label: intl.formatMessage(
                  { id: 'label.considerarAreasSubordinadas' },
                  { areas: resources.areas }
                ),
                value: filtro.considerarAreasSubordinadas,
                requestChange: (value) =>
                  onChangeFiltro('considerarAreasSubordinadas', value),
              }}
            />
          </Col>
          {!ehConfidencial && (
            <Col md={12}>
              <ColaboradorEGrupoSimplificadoLookup
                abrirEmDrawer
                exibirGrupos
                labelComoTitulo
                compactMulti
                multi
                data={{ ocultarInativos: true }}
                model={{
                  label: capitalizeFirstLetter(resources.colaboradores),
                  value: filtro.colaboradoresGrupos,
                  requestChange: (value) =>
                    onChangeFiltro('colaboradoresGrupos', value),
                }}
              />
            </Col>
          )}
          <Col md={6}>
            <DatePicker
              autoFormatDate
              model={{
                label: intl.formatMessage({ id: 'labelDataEnvioInicio' }),
                value: filtro.dataEnvioInicio,
                requestChange: (value) =>
                  onChangeFiltro('dataEnvioInicio', value),
              }}
            />
          </Col>
          <Col md={6}>
            <DatePicker
              autoFormatDate
              model={{
                label: intl.formatMessage({ id: 'labelDataEnvioFim' }),
                value: filtro.dataEnvioFim,
                requestChange: (value) => onChangeFiltro('dataEnvioFim', value),
              }}
            />
          </Col>
        </Row>
      </PanelCollapse>
    </Drawer>
  );
};

export default RespostasFiltroDrawer;
